var VERSION = "1.3.5";
export {
  VERSION
};
//# sourceMappingURL=version.js.map
